import type { CurrencyId, RewardBundle, Wallet } from '../core/types';

export const createWallet = (): Wallet => ({ gold: 12000, gems: 3200, tickets: 10, expCrystals: 40, traitTokens: 12, ascensionCrystals: 8, evolutionMaterials: 3, relicDust: 120, raidTokens: 0, eventCurrency: 0, secretFragments: 0 });

export class WalletService {
  constructor(private readonly wallet: Wallet) {}

  canAfford(cost: Partial<Wallet>): boolean {
    return Object.entries(cost).every(([id, amount]) => Number.isInteger(amount) && (this.wallet[id as CurrencyId] ?? 0) >= (amount ?? 0));
  }

  spend(cost: Partial<Wallet>): void {
    if (Object.values(cost).some((amount) => !Number.isInteger(amount) || (amount ?? 0) < 0)) throw new Error('Currency costs must be non-negative integers');
    if (!this.canAfford(cost)) throw new Error('Insufficient currency');
    for (const [id, amount] of Object.entries(cost)) this.wallet[id as CurrencyId] -= amount ?? 0;
  }

  grant(reward: RewardBundle): void {
    for (const [id, amount] of Object.entries(reward)) {
      if (id === 'playerExp') continue;
      if (!Number.isInteger(amount) || (amount ?? 0) < 0) throw new Error('Currency rewards must be non-negative integers');
      const currency = id as CurrencyId;
      this.wallet[currency] = Math.min(Number.MAX_SAFE_INTEGER, this.wallet[currency] + (amount ?? 0));
    }
  }

  snapshot(): Wallet { return { ...this.wallet }; }
}
